import { Skeleton } from '@/components/ui/skeleton'

// 预定义的骨架屏高度，模拟瀑布流效果（16:9 到 9:16 的各种比例）
const SKELETON_HEIGHTS = [
  '280px',
  '380px',
  '250px',
  '420px',
  '300px',
  '350px',
  '400px',
  '290px',
  '360px',
  '260px',
  '390px',
  '280px',
  '320px',
  '370px'
]

/**
 * 区域标题骨架屏（标题 + View All 按钮）
 */
function SectionHeaderSkeleton({ className }: { className?: string }) {
  return (
    <div className={`flex items-end justify-between ${className || ''}`}>
      <div>
        <Skeleton className="h-9 w-40" />
        <Skeleton className="mt-1 h-5 w-56" />
      </div>
      <Skeleton className="h-9 w-20 rounded-lg" />
    </div>
  )
}

/**
 * Playground 模板网格骨架屏
 * 20 个模板，5 列
 */
function PlaygroundSkeleton() {
  return (
    <div className="grid w-full max-w-full grid-cols-2 gap-4 @md:grid-cols-3 @lg:grid-cols-4 @xl:grid-cols-5">
      {Array.from({ length: 20 }).map((_, index) => (
        <div key={index} className="flex flex-col">
          <Skeleton className="aspect-video w-full rounded-[6px]" />
          <Skeleton className="mt-2 h-6 w-3/4" />
          <Skeleton className="mt-1 h-5 w-full" />
        </div>
      ))}
    </div>
  )
}

/**
 * Tools 工具卡片骨架屏
 * 横向滚动的工具卡片
 */
function ToolsSkeleton() {
  return (
    <div className="relative mt-5 w-full overflow-hidden">
      <div className="flex gap-2 overflow-hidden md:gap-1">
        {Array.from({ length: 7 }).map((_, index) => (
          <div
            key={index}
            className="flex w-[140px] flex-shrink-0 flex-col md:w-[calc((100%-6*4px)/7)]"
          >
            <Skeleton className="aspect-video w-full rounded-[2px]" />
            <Skeleton className="mt-2 h-6 w-3/4" />
            <Skeleton className="mt-1 h-5 w-full" />
          </div>
        ))}
      </div>
    </div>
  )
}

/**
 * Card Masonry 骨架屏
 * 瀑布流卡片
 */
function CardMasonrySkeleton() {
  return (
    <div className="mt-5 columns-2 gap-1 md:columns-3 lg:columns-7">
      {SKELETON_HEIGHTS.map((height, index) => (
        <Skeleton
          key={index}
          className="mb-1 w-full break-inside-avoid rounded-[2px]"
          style={{ height }}
        />
      ))}
    </div>
  )
}

/**
 * Apps 卡片网格骨架屏
 * 10 个卡片，2 列移动端，10 列桌面端
 */
function AppsSkeleton() {
  return (
    <div className="mt-5 grid w-full grid-cols-2 gap-1 md:grid-cols-10">
      {Array.from({ length: 10 }).map((_, index) => (
        <Skeleton key={index} className="aspect-[3/4] w-full rounded-[2px]" />
      ))}
    </div>
  )
}

/**
 * Explore 内容区域骨架屏
 * 在服务端数据加载完成前显示（不包含 Header）
 */
export function ExploreContentSkeleton() {
  return (
    <div className="page-container">
      {/* Playground 区域 */}
      <SectionHeaderSkeleton />
      <div className="mt-5">
        <PlaygroundSkeleton />
      </div>

      {/* Popular 区域 */}
      <SectionHeaderSkeleton className="mt-8" />
      <CardMasonrySkeleton />

      {/* Apps 区域 */}
      <SectionHeaderSkeleton className="mt-8" />
      <AppsSkeleton />

      {/* Tools 区域 */}
      <SectionHeaderSkeleton className="mt-8" />
      <ToolsSkeleton />
    </div>
  )
}
